import { useEffect, useRef, useState } from 'react';
import { Notification } from '../models/notification';

export const useNotificationsSocket = (
  onNewNotification: (notifications: Notification[]) => void,
  userSigned: boolean,
) => {
  //const socketRef = useRef<Socket | null>(null);
  const [isConnected] = useState(false);

  const onNewNotificationRef = useRef(onNewNotification);
  useEffect(() => {
    onNewNotificationRef.current = onNewNotification;
  }, [onNewNotification]);

  useEffect(() => {
    // Websocket connections disabled for testing
    return;
  }, [userSigned]);

  return { isConnected };
};
